<template>
  <li class="choosable-gift__item">
    <div class="choosable-gift__thumbnail">
      <v-image :just-one="true" :src="gift.image" :alt="gift.name" responsive />
    </div>

    <div class="choosable-gift__content">
      <div class="choosable-gift__title">
        {{ gift.name }}
      </div>

      <v-button
        v-if="gift.in_stock"
        :label="
          currentVariantId === gift.variant_id ? $t('selected') : $t('select')
        "
        smallest
        discrete
        :class="[
          'choosable-gift__change',
          {
            'choosable-gift__selected': currentVariantId === gift.variant_id,
          },
        ]"
        :loading="selectingNewVariant"
        @click="selectNewVariant(gift)"
      />

      <out-of-stock v-else />
    </div>
  </li>
</template>

<script>
import OutOfStock from '~/components/product/OutOfStock'
import VImage from '~/components/VImage.vue'
import VButton from '~/components/v-button/VButton.vue'
import appendUrlParam from '~/utils/appendUrlParam'

export default {
  components: {
    OutOfStock,
    VImage,
    VButton,
  },
  props: {
    gift: {
      type: Object,
      required: true,
    },
    currentVariantId: {
      type: Number,
      required: true,
    },
    lineItemId: Number,
    newChoosableGift: Boolean,
  },
  data() {
    return {
      selectingNewVariant: false,
    }
  },
  methods: {
    async selectNewVariant(newVariant) {
      const newVariantId = newVariant.variant_id
      if (newVariantId === this.currentVariantId || this.selectingNewVariant)
        return
      this.selectingNewVariant = true
      try {
        if (this.lineItemId) {
          const params = {
            ...this.$store.getters.storeInfo,
            line_item_id: this.lineItemId,
            variant_id: newVariantId,
          }
          const choosableEndpoint = this.newChoosableGift
            ? 'carts/update_gift_promotion'
            : 'carts/update_gift'
          await this.$axios.$post(appendUrlParam(choosableEndpoint, params))
        }
        this.$emit('newVariant', newVariant)
      } catch (err) {
        this.$displayTopMessage(this.$t('action_error'), {
          type: 'error',
        })
      } finally {
        this.selectingNewVariant = false
      }
    },
  },
}
</script>

<style></style>
